import jQuery from 'jquery';
import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

Swiper.use([Navigation, A11y, Keyboard]);

jQuery.widget('ep.carousel', {
    options: {
        isPopup: false,
        dotdotdot: true,
        i18n: {
            prev: ``,
            next: ``,
            first: ``,
            last: ``,
            label: ``,
        }
    },

    _create: function () {
        const itemsWrapper = this.element.find('.swiper')[0];
        const isPopup = this.options.isPopup;
        const i18n = this.options.i18n;
        const self = this;

        const itemWidth = isPopup ? 140 : 220;
        const maxItems = isPopup ? 3 : 5;

        const breakpoints = {};
        for (let i = 2; i <= maxItems; i++) {
            const breakpointWidth = itemWidth * i + 100;
            breakpoints[breakpointWidth] = {
                slidesPerView: i,
                slidesPerGroup: i
            };
        }

        const nextButton = this.element.closest('.carousel-wrapper').find('.swiper-button-next')[0];
        const prevButton = this.element.closest('.carousel-wrapper').find('.swiper-button-prev')[0];
        const swiperContainer = this.element.closest('.carousel-wrapper')[0];

        // Make only visible slides navigable with keyboard
        const updateSlideVisibility = (swiper) => {
            swiper.slides.forEach((slide) => {
                const isVisible = slide.classList.contains('swiper-slide-visible');
                slide.querySelectorAll('a, input, select, textarea, [tabindex]').forEach(el => {
                    el.setAttribute('tabindex', isVisible ? '0' : '-1');
                });
            });
        };

        let preloadTimeout;

        this._swiper = new Swiper(itemsWrapper, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            keyboard: {
                enabled: false, // Enable only on focus
                onlyInViewport: true,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: i18n.prev,
                nextSlideMessage: i18n.next,
                firstSlideMessage: i18n.first,
                lastSlideMessage: i18n.last,
                slideLabelMessage: null,
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: breakpoints,
            on: {
                init: function () {
                    self._preloadNextImages(this);
                    updateSlideVisibility(this);
                    if (i18n.label) {
                        swiperContainer.setAttribute('aria-label', i18n.label);
                    }
                    this.navigation.update(); // Ensure arrows match state
                },
                slideChange: function () {
                    clearTimeout(preloadTimeout);
                    preloadTimeout = setTimeout(() => {
                        self._preloadNextImages(this);
                        updateSlideVisibility(this);
                        this.navigation.update();
                    }, 50);
                }
            }
        });

        // Enable keyboard navigation only on focus
        swiperContainer.addEventListener('focusin', () => {
            self._swiper.keyboard.enable();
        });

        swiperContainer.addEventListener('focusout', () => {
            // Delay to allow focus to move between internal elements
            setTimeout(() => {
                if (!swiperContainer.contains(document.activeElement)) {
                    self._swiper.keyboard.disable();
                }
            }, 0);
        });

        if (this.options.dotdotdot) {
            jQuery(this.element).find('.carousel-text-link').dotdotdot();
        }
    },

    _preloadNextImages: function(sliderInstance) {
        const slidesToShow = sliderInstance.params.slidesPerView;
        const slidesPerGroup = sliderInstance.params.slidesPerGroup || slidesToShow;
        const currentIndex = sliderInstance.activeIndex;

        for (let i = 0; i < slidesPerGroup; i++) {
            const slide = sliderInstance.slides[currentIndex + slidesToShow + i];
            if (slide) {
                const img = slide.querySelector('img');
                if (img && img.getAttribute('loading') !== 'eager') {
                    img.setAttribute('loading', 'eager');
                    slide.classList.add('nextSlide');
                }
            }
        }
    },

    add: function (items) {
        const wrapper = this._swiper.wrapperEl;
        items.appendTo(wrapper);
        this._swiper.update();
        this._swiper.navigation.update();
        items.find('.carousel-text-link').dotdotdot();
    }
});

export default function () {}
